export default __webpack_public_path__ + "static/media/card-theme5.9288aa65.svg";